<template>
  <div
    ref="container"
    class="local-lottie"
    :style="{
      width: props.width,
      height: props.height,
    }"
    aria-label="location"
  ></div>
</template>

<script setup lang="ts">
import type { AnimationItem } from 'lottie-web'
import animationData from '~/assets/lottie/location.json'
import exAnimationData from '~/assets/lottie/expo-location.json'

/** 组件入参，控制 lottie 容器尺寸。 */
const props = withDefaults(
  defineProps<{
    width?: string
    height?: string
    isExpo?: boolean
  }>(),
  {
    width: '80px',
    height: '80px',
    isExpo: false,
  },
)

/** lottie 挂载容器引用。 */
const containerRef = useTemplateRef<HTMLDivElement>('container')
/** lottie 动画实例，卸载时用于销毁。 */
let animation: AnimationItem | null = null

/** 挂载后按需加载 lottie-web 并创建定位动画。 */
onMounted(async () => {
  const container = containerRef.value
  if (!container) return

  const { default: lottie } = await import('lottie-web')
  animation = lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: props.isExpo ? exAnimationData : animationData,
  })
})

/** 组件卸载前销毁动画实例，避免内存泄漏。 */
onBeforeUnmount(() => {
  animation?.destroy()
  animation = null
})
</script>

<style scoped lang="less">
.local-lottie {
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(svg) {
    display: block;
  }
}
</style>
